import { HPSobBusinessUnits } from './HPSobBusinessUnits'

export const categoriesForBU = {
  [HPSobBusinessUnits.JBPSupplies]: ['jbp-print-ink', 'jbp-print-toner'],
  [HPSobBusinessUnits.JBPPrint]: ['jbp-print-ops', 'jbp-print-hps'],
  [HPSobBusinessUnits.JBPPC]: ['jbp-pc-bps', 'jbp-pc-cps'],
}
